import { useHistory } from "react-router-dom"
import { Link } from '@mui/material';
import { IState, ticketsContext } from "../../TicketsContext";
import { TicketQueues, TicketStatus } from "helpers/Enums";
import { useContext } from "react";

interface IProps {
    assignee: string
    value: number
}

let ClickableAssignee = (props: IProps) => {
    let history = useHistory<IState>();
    let { defaultSearch } = useContext(ticketsContext);

    return (
        <>
            {props.value === 0 && '-'}
            {props.value > 0 &&
                <Link
                    component="button"
                    onClick={() => history.push(
                        history.location.pathname,
                        {
                            search: {
                                ...defaultSearch,
                                assigneeUserName: props.assignee,
                                ticketQueue: TicketQueues.AdvancedSearch,
                                status: [
                                    TicketStatus.Backlog,
                                    TicketStatus.InProgress,
                                    TicketStatus.WaitingForCustomer,
                                    TicketStatus.WaitingOnSimec
                                ]
                            },
                        }
                    )}
                >
                    {props.value}
                </Link>
            }
        </>
    )
}
export default ClickableAssignee